import { BALANCE } from '@/config/balance';
import { ElephantStage } from '@/types';

export interface ScoreSnapshot {
  total: number;
  maxStage: ElephantStage;
}

export class ScoreSystem {
  private total = 0;
  private maxStage: ElephantStage = ElephantStage.TINY;

  recordCollect(value: number, multiplier: number): number {
    const points = Math.round(value * multiplier);
    this.total += points;
    return points;
  }

  recordStage(stage: ElephantStage): void {
    if (stage > this.maxStage) this.maxStage = stage;
  }

  finalize(survivedToEnd: boolean): void {
    if (survivedToEnd) this.total += BALANCE.game.timeBonus;
  }

  snapshot(): ScoreSnapshot {
    return { total: this.total, maxStage: this.maxStage };
  }

  reset(): void {
    this.total = 0;
    this.maxStage = ElephantStage.TINY;
  }
}
